// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__knoQn","popularItems":"Header_popularItems__c7WN9","policyContainer":"Header_policyContainer__mwkKR","policy":"Header_policy__Bgw4h"};